module.exports = __webpack_public_path__ + "static/img/home1.94fca13.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home1.webp
// module id = 5aq+
// module chunks = 3